import React from "react";

export default function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="relative bg-ink pt-32 pb-16 overflow-hidden">
      <div className="pointer-events-none absolute -top-16 right-10 h-72 w-72 rounded-full bg-gold/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-gold/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {eyebrow && (
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-gold">
            <span className="h-1.5 w-1.5 rounded-full bg-gold" /> {eyebrow}
          </span>
        )}
        <h1 className="mt-4 font-display text-4xl sm:text-5xl text-white max-w-3xl leading-tight">{title}</h1>
        {subtitle && <p className="mt-4 text-lg text-white/60 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
